module.exports = __webpack_public_path__ + "static/media/logo.646c2cc9.png";